module.exports = __webpack_public_path__ + "img/chord.9c623f26.png";